<template>
    <editor-sidebar class="properties-block" floating has-tabs :visible="visible" :no-slide="noSlide">
        <template v-if="!addChildMode && block" #header>
            <h4 class="sidebar-title text-uppercase mr-auto cursor-text" @click="renameBlock">{{block.displayName|tr}}</h4>
            <b-dropdown v-if="block.type !== 'footer' && block.type !== 'menu' && !readonly" no-caret right variant="light" class="ml-2 mr-3">
                <template #button-content>
                    <i class="fas fa-ellipsis-h-alt"/>
                </template>
                <b-dropdown-item @click="block.scrollTo()">
                    <i class="fas fa-crosshairs-simple"/>
                    <span v-tr>Scroll To|Afficher</span>
                    <span class="shortcut">Ctrl + Home</span>
                </b-dropdown-item>
                <template v-if="!isChild">
                    <b-dropdown-item @click="$emit('move-up', block)" :disabled="index === 0">
                        <i class="fas fa-arrow-up"/>
                        <span v-tr>Move Up|Monter</span>
                        <span class="shortcut">Ctrl + Shift + ↑</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="$emit('move-down', block)" :disabled="index === count - 1">
                        <i class="fas fa-arrow-down"/>
                        <span v-tr>Move Down|Descendre</span>
                        <span class="shortcut">Ctrl + Shift + ↓</span>
                    </b-dropdown-item>
                </template>
                <b-dropdown-divider/>
                <b-dropdown-header><span v-tr>Transform Block|Transformer le bloc</span></b-dropdown-header>
                <b-dropdown-item @click="convertBlockMode = true">
                    <i class="fas fa-arrow-progress"/>
                    <span v-tr>Change type of block|Changer de type de bloc</span>
                </b-dropdown-item>
                <b-dropdown-item @click="$emit(`wrap-block`)">
                    <i class="fas fa-arrow-up-from-square"/>
                    <span v-tr>Wrap block|Mettre dans un container</span>
                </b-dropdown-item>
                <b-dropdown-item v-if="block.children && block.children.length === 1" @click="replaceBlockWithChild">
                    <i class="fas fa-arrow-down-to-square"/>
                    <span v-tr>Replace with child|Remplacer par le contenu</span>
                </b-dropdown-item>
                <b-dropdown-divider/>
<!--                <b-dropdown-item @click="$emit('wrap', block)">-->
<!--                    <i class="fas fa-copy"/>-->
<!--                    <span v-tr>Wrap|Envopper</span>-->
<!--                    <span class="shortcut">Ctrl + P</span>-->
<!--                </b-dropdown-item>-->
                <b-dropdown-item @click="$emit('cut-block', block)">
                    <i class="fas fa-cut"/>
                    <span v-tr>Cut|Couper</span>
                    <span class="shortcut">Ctrl + Shift + X</span>
                </b-dropdown-item>
                <b-dropdown-item @click="$emit('copy-block', block)">
                    <i class="fas fa-copy"/>
                    <span v-tr>Copy|Copier</span>
                    <span class="shortcut">Ctrl + Shift + C</span>
                </b-dropdown-item>
                <b-dropdown-item @click="$emit('duplicate', block)">
                    <i class="fas fa-clone"/>
                    <span v-tr>Duplicate|Dupliquer</span>
                    <span class="shortcut">Ctrl + Shift + D</span>
                </b-dropdown-item>
                <b-dropdown-item @click="saveAsTemplate">
                    <i class="fas fa-save"/>
                    <span v-tr>Save as Template|Enregistrer comme modèle</span>
                </b-dropdown-item>
                <b-dropdown-item @click="$emit('paste-block', block)" :disabled="isClipboardEmpty">
                    <i class="fas fa-paste"/>
                    <span v-tr>Paste|Coller</span>
                    <span class="shortcut">Ctrl + Shift + V</span>
                </b-dropdown-item>
                <b-dropdown-item v-if="block.typeDef.isParent" @click="$emit('paste-block-child', block)" :disabled="isClipboardEmpty">
                    <i class="fak fa-solid-clipboard-circle-arrow-down"/>
                    <span v-tr>Paste Inside|Coller dedans</span>
                    <span class="shortcut">Ctrl + Alt + Shift + V</span>
                </b-dropdown-item>
                <b-dropdown-item @click="$emit('paste-block-style', block)" :disabled="isClipboardEmpty">
                    <i class="fas fa-brush"/>
                    <span v-tr>Paste Style|Coller style</span>
                    <span class="shortcut">Ctrl + Shift + Alt + V</span>
                </b-dropdown-item>
                <b-dropdown-divider/>
                <b-dropdown-item @click="autoTranslate(false)">
                    <i class="fas fa-language"/>
                    <span v-tr>Translate Block missing texts|Traduire les textes manquants du bloc</span>
                    <span class="shortcut text-uppercase">{{ displayLanguage }} -> {{ translateLanguage }}</span>
                </b-dropdown-item>
                <b-dropdown-item @click="autoTranslate(true)">
                    <i class="fak fa-solid-language-rotate-right"/>
                    <span v-tr>Replace Block Translation|Remplacer la traduction du bloc</span>
                    <span class="shortcut text-uppercase">{{ displayLanguage }} -> {{ translateLanguage }}</span>
                </b-dropdown-item>

                <b-dropdown-divider/>

                <b-dropdown-item @click="swapLanguageTexts()">
                    <i class="fas fa-shuffle"/>
                    <span v-tr>Swap Translation Texts|Échanger la traduction des textes</span>
                </b-dropdown-item>
                <template v-if="hasTextComponents">
                    <b-dropdown-divider/>
                    <b-dropdown-item @click="toggleHtmlEditor">
                        <i class="fas fa-code"/>
                        <span v-tr>{{ isHtmlEditorEnabled ? 'Hide' : 'Show' }} HTML Editor|{{ isHtmlEditorEnabled ? 'Masquer' : 'Afficher' }} Éditeur HTML</span>
                    </b-dropdown-item>
                </template>
                <b-dropdown-item @click="block.toggleHidden()">
                    <i :class="block.isHiddenAll ? 'fas fa-eye' : 'fas fa-eye-slash'"/>
                    <span v-tr>{{ block.isHiddenAll ? 'Show' : 'Hide' }} Block|{{ block.isHiddenAll ? 'Afficher' : 'Masquer' }} Bloc</span>
                </b-dropdown-item>
                <b-dropdown-divider/>
                <e-button-confirm dropdown-item dropdown-class="text-danger" @click="$emit('delete', block)"
                                  confirm-title="Delete?|Supprimer?" button-text="Delete|Supprimer" :icon="getPublicIcon('trash')" :title="'Delete|Supprimer'|tr" v-b-tooltip>
                    <i class="fas fa-trash"/>
                    <span v-tr>Delete|Supprimer</span>
                    <span class="shortcut">Ctrl + Delete</span>
                </e-button-confirm>
            </b-dropdown>
            <b-btn variant="primary" @click="close">
                <span v-tr>Done|Valider</span>
            </b-btn>
        </template>

        <template v-if="block">
            <properties-select-block v-if="convertBlockMode" :visible="convertBlockMode" @select-block="convertBlock" title="Select Block|Choisir un block" @close="convertBlockMode = false;"/>
            <properties-select-block v-if="addChildMode" child-only :visible="addChildMode" @select-block="createChild" :child-classes="block.childClasses" @close="addChildMode = false;"/>

            <div v-if="blockSelection.length > 1" class="breadcrumb selection">
                <span v-for="(block, index) in blockSelection" :key="`selection-${block.id}`">
                    <i v-if="index > 0" class="fas fa-caret-right"/>
                    <b-btn @click="selectBlock(block)" size="xs" variant="white">{{block.displayName|tr}}</b-btn>
                </span>
            </div>

            <b-tabs class="tabs-pills" v-model="mainTab">
                <b-tab :title="'Content|Contenu'|tr" class="padding-responsive-btn-space">
                    <sidebar-group v-if="block.typeDef.isParent" title="Content|Contenu">
                        <b-card class="mb-3" no-body>
                            <vuedraggable v-model="block.children" class="list-group" handle=".drag-handle"
                                          ghost-class="list-item-ghost" drag-class="list-item-drag" animation="150" @start="drag = true">
                                <block-list-view-item v-for="child in block.children" :block="child" :key="'properties-' + child.id" :readonly="block.childrenReadonly"
                                                      @click="$emit('block-selected', child)" @duplicate="block.duplicateChild(child)" @delete="block.deleteChild(child)"/>
                            </vuedraggable>
                        </b-card>

                        <b-btn v-if="!block.childrenReadonly" variant="primary" block class="mb-3" @click="addChild()" :disabled="block.children.length >= block.maxChildren">
                            <template v-if="block.children.length >= block.maxChildren">
                                <span v-tr>Add (Limit Reached)|Ajouter (Limite atteinte)</span>
                            </template>
                            <template v-else>
                                <i class="fas fa-plus mr-1"/>
                                <span v-tr>Add Content|Ajouter contenu</span>
                            </template>
                        </b-btn>
                    </sidebar-group>

                    <sidebar-group v-if="block.typeDef.isParent" :title="tr(`Template|Modèle`)">
                        <template #actions>
                            <b-checkbox class="toggle-active float-right" size="lg" v-model="block.enableTemplate"/>
                        </template>

                        <template v-if="block.enableTemplate">
                            <b-form-group label-cols="4" :label="tr(`Style of|Style de`)">
                                <b-form-select v-model="block.templateItemId" @input="block.updateTemplateItem()">
                                    <option v-for="child of block.children" :value="child.id">{{child.displayName}}</option>
                                </b-form-select>
                            </b-form-group>

                            <b-form-group>
                                <b-btn @click="block.applyTemplate(); $forceUpdate()" size="sm" variant="light-primary" block>
                                    <i class="fas fa-sync mr-2"/>
                                    <span v-tr>Apply Style|Appliquer le style</span>
                                </b-btn>
                            </b-form-group>
                        </template>
                    </sidebar-group>
                    <sidebar-group v-else-if="!isTemplate && parentBlock && parentBlock.enableTemplate" title="Template">
                        <b-form-group :label="tr(`Template|Modèle`)" label-cols="4">
                            <b-btn @click="selectBlock(parentBlock.templateItem)" variant="outline" block :disabled="!parentBlock.templateItem"
                                    :title="tr(`Select template|Sélectionner le modèle`)">
                                {{parentBlock.templateItem ? parentBlock.templateItem.displayName : tr(`None|Aucun`)}}
                            </b-btn>
<!--                            <b-input-group>-->
<!--                                <b-input readonly :value="parentBlock.templateItem ? parentBlock.templateItem.displayName : tr(`None|Aucun`)"/>-->
<!--                                <b-btn><i class="fas fa-fw- fa-edit"/></b-btn>-->
<!--                            </b-input-group>-->
                        </b-form-group>

                        <b-form-group>
                            <b-checkbox v-model="block.bypassTemplate">
                                <span v-tr>Enable Customization (bypass template)|Personnaliser (désactiver le modèle)</span>
                            </b-checkbox>
                        </b-form-group>
                    </sidebar-group>

                    <div v-if="isSyncWithTemplate" class="bg-white border-bottom p-2">
                        <h5 class="mt-0 text-warning" v-tr>Item is using a template|Utilise un template</h5>
                        <div class="form-help " v-tr>You can't edit this item style and layout|Vous ne pouvez pas modifier le style de cet élément</div>
                        <b-btn @click="block.bypassTemplate = true" size="sm" variant="light" class="mt-2">
                            <i class="fas fa-unlock mr-2"/>
                            <span v-tr>Disable Template|Désactiver le modèle</span>
                        </b-btn>
                    </div>

                    <div v-if="isTemplate" class="bg-white p-2 border-bottom">
                        <b-btn @click="parentBlock.applyTemplate(); $forceUpdate()" size="sm" variant="secondary" class="float-right">
                            <i class="fas fa-sync mr-2"/>
                            <span v-tr>Apply Style|Appliquer le style</span>
                        </b-btn>

                        <h5 class="mt-0 text-info" v-tr>Template|Modèle</h5>
                        <div class="form-help" style="clear: both;" v-tr>The style is shared with other items|Le style s'applique à d'autre éléments</div>
                    </div>

                    <template v-if="!isSyncWithTemplate">
                        <slot></slot>

                        <sidebar-group title="Layout|Disposition">
                            <b-form-group v-if="block.layoutPresets.length > 0">
                                <btn-responsive-prop v-model="block" field="layoutPresets" no-label/>
                                <btn-layout-preset v-for="layout in block.mediaProxy.layoutPresets" :key="`layout-${layout.id}`" v-model="block.mediaProxy.layout" :type="block.type" :layout="layout"/>
                            </b-form-group>

                            <b-form-group>
                                <btn-responsive-prop v-model="block" field="align" no-label/>
                                <btn-layout-align v-model="block.mediaProxy.align" align="inherit"/>
                                <btn-layout-align v-model="block.mediaProxy.align" align="left"/>
                                <btn-layout-align v-model="block.mediaProxy.align" align="center"/>
                                <btn-layout-align v-model="block.mediaProxy.align" align="right"/>
                                <btn-layout-align v-model="block.mediaProxy.align" align="justify"/>
                            </b-form-group>

                            <slot name="layout"></slot>
                        </sidebar-group>

                        <sidebar-group title="Color Scheme|Palette de couleur">
                            <b-form-group>
                                <btn-responsive-prop v-model="block" field="colorScheme" no-label/>
                                <div>
                                    <btn-color-scheme v-for="scheme in cmsWebsite.design.colorSchemes" :key="`scheme-${scheme.id}`" v-model="block.mediaProxy.colorScheme" :color-scheme="scheme"/>
                                    <btn-color-scheme v-model="block.mediaProxy.colorScheme" v-if="isChild" :color-scheme="{}"/>
                                </div>
                            </b-form-group>

                            <slot name="colors"/>
                        </sidebar-group>

                        <sidebar-group title="Background|Arrière-plan">
                            <b-form-group>
                                <template #label>
                                    <btn-responsive-prop v-model="block" field="background"/>
                                </template>
                                <b-select v-model="block.background">
                                    <option value="none" v-tr>Default|Défaut</option>
                                    <option value="image" v-tr>Image</option>
                                    <option value="color" v-tr>Color|Couleur</option>
                                </b-select>
                            </b-form-group>

                            <b-form-group v-if="block.background === 'image'">
                                <input-image v-model="block.backgroundImage"/>
                            </b-form-group>

                            <b-form-group v-else-if="block.background === 'color'">
                                <input-color v-model="block.backgroundColor" allow-transparent button block :label="'Custom Color|Couleur personnalisée'"/>
                            </b-form-group>

                            <b-form-group>
                                <input-border-radius v-model="block.backgroundRadius">
                                    <template #prepend>
                                        <btn-responsive-prop v-model="block" field="backgroundRadius" no-label/>
                                    </template>
                                </input-border-radius>
                            </b-form-group>

                            <slot name="background"/>
                        </sidebar-group>

                        <sidebar-group title="Spacing|Espacement">
                            <input-padding title="Padding" v-model="block.padding"/>
                            <input-padding title="Margins|Marges" v-model="block.margin"/>
                            <b-form-group>
                                <template #label>

                                    <span v-tr>Gap|Espacement</span>
                                </template>
                                <b-row>
                                    <b-col>
                                        <b-input-group>
                                            <b-input-group-text><i class="fas fa-arrows-from-dotted-line fa-rotate-90"/></b-input-group-text>
                                            <e-input type="text" v-model="block.gap.x"/>
                                        </b-input-group>
                                    </b-col>
                                    <b-col>
                                        <b-input-group>
                                            <b-input-group-text><i class="fas fa-arrows-from-dotted-line"/></b-input-group-text>
                                            <e-input type="text" v-model="block.gap.y"/>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <slot name="spacing"/>
                        </sidebar-group>

                        <properties-component-border title="Borders|Bords" :value="block.borders">
                            <slot name="borders"/>
                        </properties-component-border>
                        <properties-component-shadow title="Shadow|Ombre" :value="block.shadow">
                            <slot name="shadows"/>
                        </properties-component-shadow>
                    </template>
                </b-tab>
                <b-tab :title="'CMS|CMS'|tr" :disabled="block.type === 'footer' && block.type === 'menu'" class="padding-responsive-btn-space">
                    <sidebar-group title="CMS Integration|Intégration CMS">
                        <b-form-group>
                            <b-checkbox switch v-model="block.cmsEnabled">
                                <span v-tr>Link to a CMS Item|Lier à un élément du CMS</span>
                            </b-checkbox>
                        </b-form-group>
                        <b-form-group v-if="block.cmsEnabled">
                            <select-cms-item v-model="block.itemId" @input="cmsItemSelected" use-store/>
                        </b-form-group>
                        <div class="form-help mb-2" v-tr>You can link this item to any CMS Item|Vous pouvez lier cet élément à n'importe quel élément du CMS</div>
                    </sidebar-group>
                    <span v-if="block.item && !isLive()">
                        {{block.item}}
                    </span>
                    <slot name="cms"></slot>
                </b-tab>
                <b-tab :title="'Advanced|Avancé'|tr" class="padding-responsive-btn-space">
                    <sidebar-group title="Device Display|Affichage par appareil">
                        <b-form-group>
                            <btn-checkbox v-model="block.mediaQuery.desktop.visible" :title="'Select if visible on desktop device|Visibilité sur ordinateur'|tr">
                                <i class="fas fa-desktop" style="font-size: 16pt;"/>
                            </btn-checkbox>
                            <btn-checkbox v-model="block.mediaQuery.tablet.visible" :title="'Select if visible on tablet device|Visibilité sur tablette'|tr">
                                <i class="fas fa-tablet-screen" style="font-size: 16pt;"/>
                            </btn-checkbox>
                            <btn-checkbox v-model="block.mediaQuery.mobile.visible" :title="'Select if visible on mobile device|Visibilité sur mobile'|tr">
                                <i class="fas fa-mobile-iphone" style="font-size: 16pt;"/>
                            </btn-checkbox>
                            <btn-checkbox v-model="block.mediaQuery.kiosk.visible" :title="'Select if visible on kiosk device|Visibilité sur kiosque'|tr">
                                <i class="fak fa-kiosk" style="font-size: 16pt;"/>
                            </btn-checkbox>
                            <btn-checkbox v-model="block.mediaQuery.wheelchair.visible" :title="'Select if visible on kiosk with wheelchair mode|Visibilité sur kiosque en mode handicapé'|tr">
                                <i class="fas fa-wheelchair" style="font-size: 16pt;"/>
                            </btn-checkbox>
                        </b-form-group>
                        <div class="form-help mb-2" v-tr>You can show or hide sections based on the user device|Vous pouvez afficher ou masquer des sections en fonction de l'appareil utilisé</div>
                    </sidebar-group>
                    <sidebar-group v-if="canAdminEyeInWireless()" title="Eye-In Settings|Config Eye-In">
                        <b-form-group :label="tr('Custom ID|ID personnalisé')">
                            <b-input-group>
                                <b-btn @click="toggleCustomId" :variant="block.hasCustomId() ? 'secondary': 'white'">
                                    <i class="fas " :class="block.hasCustomId() ? 'fa-lock' : 'fa-unlock'"/>
                                </b-btn>
                                <e-input v-if="!block.hasCustomId()" v-model="block.id" readonly/>
                                <e-input v-else v-model="block.customId"/>
                            </b-input-group>
                            <div class="form-help mt-2" v-tr>Custom ID can be used for CSS and Tests|L'ID peut être utilisé pour du CSS et des tests</div>
                        </b-form-group>
                    </sidebar-group>
                    <sidebar-group v-if="canAdminEyeInWireless()" title="Custom Style|Style personnalisé" no-left-padding>
                        <template v-if="mainTab === TABS.ADVANCED">
                            <b-form-group :label="tr('Custom Class|Classe personnalisée')">
                                <b-input type="text" v-model="block.customClass"/>
                            </b-form-group>
                            <b-form-group :label="tr('Custom CSS|CSS personnalisé')">
    <!--                            <b-textarea v-model="block.css" style="min-height: 250px"/>-->
                                <monaco-editor v-model="block.css" lang="css" :block="block"/>
                            </b-form-group>
                        </template>
                    </sidebar-group>
                    <slot name="advanced"></slot>
                </b-tab>
            </b-tabs>
        </template>

        <b-modal v-model="templateModalVisible" :title="tr(`Save as Template|Enregistrer comme modèle`)" size="lg" @ok="saveTemplate">
            <div class="template-modal-content">
                <b-form-group :label="tr(`Template Name|Nom du modèle`)">
                    <b-input v-model="templateName" :placeholder="tr(`Enter template name|Entrez le nom du modèle`)" />
                </b-form-group>

                <b-form-group :label="tr(`Description|Description`)">
                    <b-textarea v-model="templateDescription" :placeholder="tr(`Optional description|Description optionnelle`)" rows="3" />
                </b-form-group>

                <b-form-group :label="tr(`Block Preview|Aperçu du bloc`)">
                    <div class="block-preview-container">
                        <block-preview :block="block" :scale="0.6" />
                    </div>
                </b-form-group>
            </div>
        </b-modal>
    </editor-sidebar>
</template>

<script>

import BlockListViewItem from "@/components/editor/properties/block-list-view-item.vue";
import BtnResponsiveProp from "@/components/editor/properties/components/btn-responsive-prop.vue";
import PropertiesComponentBorder from "@/components/editor/properties/components/properties-component-border.vue";
import PropertiesComponentShadow from "@/components/editor/properties/components/properties-component-shadow.vue";
import SidebarGroup from "@/components/editor/properties/components/sidebar-group.vue";
import BtnCheckbox from "@/components/editor/properties/inputs/btn-checkbox.vue";
import InputBorderRadius from "@/components/editor/properties/inputs/input-border-radius.vue";
import InputColor from "@/components/editor/properties/inputs/input-color.vue";
import InputImage from "@/components/editor/properties/inputs/input-image.vue";
import BtnColorScheme from "@/components/editor/properties/inputs/btn-color-scheme.vue";
import BtnLayoutAlign from "@/components/editor/properties/inputs/btn-layout-align.vue";
import BtnLayoutPreset from "@/components/editor/properties/inputs/btn-layout-preset.vue";
import SelectCmsItem from "@/components/editor/properties/inputs/select-cms-item.vue";
import PropertiesSelectBlock from "@/components/editor/properties/properties-select-block.vue";

// properties-block #hot-reload-debug
import EditorSidebar from "@/layout/editor-sidebar.vue";
import InputPadding from "@components/editor/properties/inputs/input-padding.vue";
import Vuedraggable from "vuedraggable";
import EButtonConfirm from "../../../../../vue-components/components/e-button-confirm.vue";
import EInput from "../../../../../vue-components/components/e-input.vue";
import BlockPreview from "@/components/editor/properties/components/block-preview.vue";
import ClipboardMixin from "@/helpers/clipboard/clipboard-mixin.js";
import MonacoEditor from "@components/editor/monaco-editor.vue";

export default {
    name: `properties-block`,
    mixins: [ClipboardMixin],
    components: {
        MonacoEditor, InputPadding,
        EInput, PropertiesComponentShadow, BtnResponsiveProp, BtnCheckbox, SelectCmsItem, InputBorderRadius, SidebarGroup, EButtonConfirm,
        BtnLayoutAlign, PropertiesComponentBorder, BtnLayoutPreset, PropertiesSelectBlock, BtnColorScheme, InputColor, Vuedraggable, InputImage, BlockListViewItem, EditorSidebar, BlockPreview},
    props: {
        value: {type: Object, required: true},
        parentBlock: {type: Object, default: null},
        blockSelection: {type: Array},
        readonly: {type: Boolean},
        noSlide: {type: Boolean},
        item: {type: Object},
        index: {type: Number},
        count: {type: Number}
    },
    data() {
        return {
            addChildMode: false,
            convertBlockMode: false,
            drag: false,
            visible: false,
            templateModalVisible: false,
            templateName: ``,
            templateDescription: ``,
            mainTab: 0,
            TABS: {
                CONTENT: 0,
                CMS: 1,
                ADVANCED: 2
            }
        }
    },
    computed: {
        componentProps() {
            return {
                block: this.block,
                boundItem: this.boundItem
            }
        },
        boundItem() {
            if (this.item) {
                return this.item;
            }
            if (this.block.cmsEnabled && this.block.item) {
                return this.block.item;
            } else if (this.cmsPage && this.block.itemType === `inherit`) {
                return this.cmsPage.item;
            } else {
                return this.block.item;
            }
        },
        boundItemList() {
            if (this.block.itemType === `inherit`) {
                return this.cms.getItemsByType(this.cmsPage.itemType);
                // return this.cmsPage.itemList;
            } else {
                return this.block.itemList;
            }
        },
        block: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        },
        isChild() {
            return this.parentBlock !== null;
        },
        isTemplate() {
            return this.parentBlock && this.parentBlock.enableTemplate && this.parentBlock.templateItemId === this.block.id;
        },
        isSyncWithTemplate() {
            return this.parentBlock && this.parentBlock.enableTemplate && this.parentBlock.templateItem && this.parentBlock.templateItemId !== this.block.id  && !this.block.bypassTemplate;
        },
        translateLanguage() {
            return this.displayLanguage.startsWith(`fr`) ? `en` : `fr`;
        },
        hasTextComponents() {
            if (!this.block) {
                return false;
            }

            const textComponentNames = [`title`, `subtitle`, `description`, `text`];

            for (const componentName of textComponentNames) {
                const component = this.block[componentName];
                if (component && component.type === `text`) {
                    return true;
                }
            }

            if (this.block.components && Array.isArray(this.block.components)) {
                return this.block.components.some(component => component.type === `text`);
            }

            for (const key in this.block) {
                const value = this.block[key];
                if (value && typeof value === `object` && value.type === `text`) {
                    return true;
                }
            }

            return false;
        },
        isHtmlEditorEnabled() {
            const blockId = this.block?.getId();
            return blockId && this.$store.state.blockHtmlEditorEnabled[blockId];
        },
    },
    mounted() {
        // to trigger slide in animation
        setTimeout(() => {
            this.visible = true;
        }, 50)
    },
    methods: {
        addChild() {
            if (this.block.childClasses.length === 1) {
                this.createChild(this.block.childClasses[0]);
            } else {
                this.addChildMode = true
            }
        },
        createChild(preset) {
            const block = new preset();
            this.block.addChild(block);
            this.addChildMode = false;
        },
        convertBlock(preset) {
            const block = new preset();
            const json = block.mergeBlockIntoJSON(this.block);
            const newBlock = new preset(json);

            this.$emit(`replace-block`, newBlock);

            // this.block.clearObject();
            // Object.assign(this.block, newBlock);
            // Object.setPrototypeOf(this.block, newBlock);
            this.convertBlockMode = false;
            // this.$forceUpdate();
        },
        replaceBlockWithChild() {
            this.$emit(`replace-block`, this.block.children[0]);
        },
        close() {
            this.visible = false;
            // to let slide out animation before hiding
            if (this.noSlide) {
                this.$emit(`close`);
            } else {
                setTimeout(_ => {
                    this.$emit(`close`);
                }, 250)
            }
        },
        toggleHtmlEditor() {
            const blockId = this.block?.getId();
            if (blockId) {
                this.$store.commit(`toggleBlockHtmlEditor`, blockId);
            }
        },
        selectBlock(block) {
            this.$emit(`block-selected`, block);
        },
        renameBlock() {
            this.showRenamePrompt(`Rename|Renommer`, `Enter the new name of this section. Leave blank to use default name.|Entrez le nouveau nom pour cette section. Laissez vide pour utiliser le nom par défaut.`, this.block.name || ``, `Rename|Renommer`, undefined, name => {
                this.block.name = name;
            });
        },
        toggleCustomId() {
            if (!this.block.hasCustomId()) {
                this.$set(this.block, `customId`, this.block.id);
            } else {
                this.$set(this.block, `customId`, null);
            }
        },
        cmsItemSelected() {
            this.block.updateCmsItem();
        },
        async autoTranslate(replaceAll = false) {
            this.showLoading(`Translating...|Traduction en cours...`);
            await this.block.translate(this.displayLanguage, this.translateLanguage, replaceAll);
            this.showSavedMessage(`Page Translated|Page traduite`);

            // Like this we can see the translation block by block
            this.$store.state.previewLanguage = this.translateLanguage;
            // this.$forceUpdate();
        },
        async swapLanguageTexts() {
            await this.block.swapLanguageTexts();
            this.$store.state.previewLanguage = this.translateLanguage;
        },
        saveAsTemplate() {
            this.templateName = this.block.displayName || ``;
            this.templateDescription = ``;
            this.templateModalVisible = true;
        },
        saveTemplate() {
            if (!this.templateName.trim()) {
                this.showToast(`Template name is required|Le nom du modèle est requis`, 3000, `error`);
                return;
            }

            const templateData = {
                name: this.templateName.trim(),
                description: this.templateDescription.trim(),
                block: this.block.toJSON()
            };

            this.$emit(`save-template`, templateData);
            this.templateModalVisible = false;
        },
    }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
    background: var(--color-lightest);
    border-top: 1px solid var(--border-color);
    border-radius: 0;
    padding: 3px;
    margin-bottom: 0;
    font-size: 9pt;
    line-height: 26px;

    .btn {
        border-radius: 3px;
        padding: 3px 6px;
        font-size: inherit;
    }

    i {
        vertical-align: middle;
        margin: 0 2px;
    }
}

.block-preview-container {
    display: grid;
    place-items: center;
    min-height: 45vh;
    padding: 1rem;
    overflow: hidden;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    background: white;
    margin-bottom: 1rem;
    pointer-events: none;
}
</style>
